module.exports = __webpack_public_path__ + "img/webhook.fc3e4e09.png";